import AxiosService from './axios.service';
import Config from '../config';

export const Axios = {
  Api: new AxiosService(Config.API_URL),
  Auth: new AxiosService(Config.AUTH_URL)
};

export { AuthService } from './auth.service';
export { LocalStorageService } from './localStorage.service';
